module.exports = __webpack_public_path__ + "img/avatar0.18534179.png";